import { Col, Row } from 'reactstrap';
import { DailyScheduleDTO } from '../../../../interfaces/DailyScheduleInterface';

interface Props {
  schedule: DailyScheduleDTO | null;
}

const DashboardSummaryBar = ({ schedule }: Props) => {
  const entries = (schedule?.rooms || []).flatMap((r) => r.entries || []);
  const scheduled = entries.length;
  const clockedIn = entries.filter((e) => e.staffStatus === 'CLOCKED_IN').length;
  const outOff = entries.filter((e) => e.staffStatus === 'OUT_OFF').length;
  const calledOut = entries.filter((e) => e.staffStatus === 'CALLED_OUT').length;

  const stats = [
    { label: 'Staff Scheduled', value: scheduled, bg: '#f0f4ff', iconBg: '#5e72e4', color: '#5e72e4', icon: '👥' },
    { label: 'Clocked In', value: clockedIn, bg: '#f0fff4', iconBg: '#2dce89', color: '#2dce89', icon: '✅' },
    { label: 'Out / Off', value: outOff, bg: '#fffbf0', iconBg: '#fb6340', color: '#fb6340', icon: '🏠' },
    { label: 'Called Out', value: calledOut, bg: '#fff0f0', iconBg: '#f5365c', color: '#f5365c', icon: '📵' },
  ];

  return (
    <Row className="dashboard-bar mb-3">
      {stats.map((s) => (
        <Col key={s.label} xs={6} md={3} className="mb-2">
          <div className="stat-card" style={{ background: s.bg }}>
            <div className="stat-icon" style={{ background: s.iconBg, color: '#fff' }}>
              {s.icon}
            </div>
            <div>
              <div className="stat-value" style={{ color: s.color }}>
                {s.value}
              </div>
              <div className="stat-label">{s.label}</div>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default DashboardSummaryBar;
